module.exports = __webpack_public_path__ + "img/pikachu.2955af0d.gif";